import React, { useEffect } from 'react';

const RiskDisclosure = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-12 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">Risk Disclosure</h1>
          <p className="text-slate-300 text-lg">Please read this important information about trading risks</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Trading Risk Disclosure</h2>
                <p className="text-slate-700 leading-relaxed">
                  Trading in financial markets involves significant risk and may not be suitable for all investors. The use of our services, including custom algorithmic trading strategies and GUI-based automation solutions, carries the risk of substantial financial losses, potentially exceeding the initial capital deployed. It is crucial to fully understand these risks before engaging in trading activities.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">No Investment Advice</h2>
                <p className="text-slate-700 leading-relaxed">
                  Visrupt does not provide investment, financial, or trading advice. We develop algorithmic strategies and trading tools based on client specifications, but the effectiveness, profitability, or reliability of any strategy is not guaranteed. Clients are solely responsible for their trading decisions, risk management, and the execution of strategies.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">No Guarantees</h2>
                <p className="text-slate-700 leading-relaxed">
                  We do not guarantee the accuracy, completeness, or reliability of any information, code, or tool provided. Market conditions, including liquidity, volatility, and execution delays, can significantly impact strategy performance. Past performance of any algorithm, strategy, or tool does not guarantee future results. Actual trading outcomes may vary due to factors such as slippage, impact costs, brokerage fees, order execution quality, and external economic influences.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Limitation of Liability</h2>
                <p className="text-slate-700 leading-relaxed">
                  Visrupt, its partners, employees, and affiliates make no guarantees regarding the profitability of any algorithmic solution. Trading involves inherent risks, including but not limited to market downturns, unexpected price movements, and technology failures. Visrupt shall not be held responsible for any losses, trading errors, or disruptions arising from the use of our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Due Diligence</h2>
                <p className="text-slate-700 leading-relaxed">
                  Investors and traders should conduct independent research, perform extensive backtesting, and consult professional financial advisors before deploying any algorithm in live markets. Trading securities, futures, forex, and other financial instruments involves substantial risk, and only risk capital should be used.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Hypothetical Performance Disclosure</h2>
                <p className="text-slate-700 leading-relaxed">
                  Hypothetical performance results have many inherent limitations. No representation is made that any account will achieve profits or losses similar to those shown in backtests or simulations. Hypothetical results do not account for real-world market conditions such as liquidity constraints, slippage, execution delays, and emotional decision-making, all of which can significantly impact actual trading results.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Testimonial Disclosure</h2>
                <p className="text-slate-700 leading-relaxed">
                  Testimonials or user feedback displayed on our platform may not be representative of all clients and do not guarantee future performance. Individual results will vary based on market conditions, execution quality, and other factors beyond Visrupt's control.
                </p>
              </div>

              <div className="bg-slate-50 p-6 rounded-lg border border-slate-200 mt-8">
                <p className="text-slate-700 font-semibold">
                  By using Visrupt's services, clients acknowledge and accept all risks associated with algorithmic trading and automation. Visrupt assumes no responsibility for direct or indirect losses incurred through the use of its solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RiskDisclosure;